import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_CONTRACTS, SET_EMPLOYEE_CONTRACT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_CONTRACT_ISLOADING,
  DELETE_EMPLOYEE_CONTRACT,
  EDIT_EMPLOYEE_CONTRACT,
  GET_EMPLOYEE_CONTRACTS,
  GET_EMPLOYEE_CONTRACT,
  REGISTER_EMPLOYEE_CONTRACT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeContract from '@/services/employee_contract';
import { Module } from 'vuex';
import { EditEmployeeContract, RegisterEmployeeContract, GetEmployeeContract } from '@/dtos/employee_contract.dto';

const employeeContract: Module<any, {}> = {
  state: {
    employeeContract: {
      data: null,
      isLoading: false,
    },
    employeeContracts: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeContract: (state: { employeeContract: any }) => state.employeeContract,
    employeeContracts: (state: { employeeContracts: any }) => state.employeeContracts,
  },
  mutations: {
    [SET_EMPLOYEE_CONTRACT]: (
      state: { employeeContract: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeContract.data = payload.data) : null,
        (state.employeeContract.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_CONTRACTS]: (
      state: { employeeContracts: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeContracts.data = payload.data) : null,
        (state.employeeContracts.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_CONTRACT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeContract.registerEmployeeContract(
        payload as RegisterEmployeeContract
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_CONTRACT, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_CONTRACT, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_CONTRACTS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_CONTRACTS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeContract.getEmployeeContracts(
        payload as GetEmployeeContract
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_CONTRACTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_CONTRACTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_CONTRACTS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_CONTRACT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeContract.getEmployeeContracts(
        payload as GetEmployeeContract
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_CONTRACT, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_CONTRACT, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_CONTRACT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeContract.editEmployeeContract(
        payload as EditEmployeeContract
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_CONTRACT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_CONTRACT, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_CONTRACT]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeContract.deleteEmployeeContract(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_CONTRACT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_CONTRACT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_CONTRACT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_CONTRACT_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_CONTRACT, { isLoading: false });
      commit(SET_EMPLOYEE_CONTRACTS, { isLoading: false });
    },
  },
};

export default employeeContract;
